import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Collapse,
  Space,
  Input,
  Form,
  Breadcrumb,
  Select,
  Upload,
  message,
  InputNumber,
  DatePicker,
  Modal,
} from "antd";
import ImgCrop from "antd-img-crop";
import {
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  addProductsServicesAPI,
  getProductByIdAPI,
  getProductsServicesAPI,
} from "../ProductsandServicesAPI";
import {
  getProductsTypeAPI,
  getDepartmentsAPI,
  getCategoriesAPI,
  getSalesTaxAPI,
  getWarrantyUnitsAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { FormattedMessage, useIntl } from "react-intl";
import InsertIntoLookup from "CommonComponents/Lookup/InsertIntoLookup";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import dayjs from "dayjs";
function AddProduct(props) {
  const intl = useIntl();
  const { TextArea } = Input;
  const { Panel } = Collapse;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyId = localStorage.getItem("CompanyId");
  const { productId: routeId } = useParams();
  const productId = props?.productData?.id || routeId;
  const [formInitialvalues, setFormInitialvalues] = useState();
  const [dropdownOpenType, setDropdownOpenType] = useState(false);
  const [dropdownOpenClass, setDropdownOpenClass] = useState(false);
  const [dropdownOpenCategory, setDropdownOpenCategory] = useState(false);
  const [productImgBase64, setProductImgBase64] = useState("");
  const [productImgName, setProductImgName] = useState("");
  const [fileList, setFileList] = useState([]);
  const [isValidFile, setIsValidFile] = useState(true);
  const productTypesList = useSelector((state) => state.lookup.productTypes);
  const departmentsList = useSelector((state) => state.lookup.departmentList);
  const categoriesList = useSelector((state) => state.lookup.categoryList);
  const salesTaxList = useSelector((state) => state.lookup.salesTaxList);
  const companyNames = useSelector((state) => state.lookup.companyNames);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  const productDetails = useSelector(
    (state) => state.productsServices.productDetails
  );
  const warrantyUnits = useSelector((state) => state.lookup.warrantyUnits);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [cost, setCost] = useState(0);
  const [markup, setMarkup] = useState(0);
  const [salesPrice, setSalesPrice] = useState(0);
  const [showInventoryInfo, setShowInventoryInfo] = useState(false);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "ProductsAndServices"
  )?.id;
  const [activeKeys, setActiveKeys] = useState(["1", "3"]);

  const handleCancel = () => {
    form.resetFields();
    navigate(`/products_services`);
  };
  const calculateSalesPrice = (costValue, markupValue) => {
    if (!markupValue && markupValue !== 0) {
      setSalesPrice(0);
      form.setFieldsValue({ salesprice: 0 });
      return;
    }
    const calculatedSalesPrice = costValue + (costValue * markupValue) / 100;
    setSalesPrice(calculatedSalesPrice.toFixed(2));
    form.setFieldsValue({ salesprice: calculatedSalesPrice.toFixed(2) });
  };
  const handleTypeChange = (value) => {
    const selectedType = productTypesList.find((type) => type.id === value);
    if (selectedType) {
      const typeName =
        selectedLanguage === "fr-FR"
          ? selectedType.nameFr
          : selectedType.nameEn;

      if (typeName === "Non-Inventory" || typeName === "Hors inventaire") {
        setShowInventoryInfo(true);
        setActiveKeys((prev) => [...prev, "2"]);
      } else {
        setShowInventoryInfo(false);
      }
    } else {
      setShowInventoryInfo(false);
    }
  };
  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const onChangeImage = async ({ fileList: newFileList }) => {
    if (newFileList.length > 0) {
      const file = newFileList[0]?.originFileObj;
      if (file) {
        try {
          const base64 = await convertFileToBase64(file);
          setProductImgBase64(base64?.split(",")[1]);
          setProductImgName(file.name);
          const updatedFileList = newFileList.map((fileItem, index) =>
            index === 0 ? { ...fileItem, status: "done" } : fileItem
          );
          setFileList(updatedFileList);
        } catch (error) {
          console.error("Error converting file to base64:", error);
          message.error("Failed to process the image. Please try again.");
        }
      }
    } else {
      Modal.confirm({
        title: intl.formatMessage({
          id: "ProductService.Doyouwanttoremovethisimage",
        }),
        icon: <ExclamationCircleOutlined />,
        okText: intl.formatMessage({ id: "Common.Yes" }),
        cancelText: intl.formatMessage({ id: "Common.No" }),
        onOk: () => {
          setFileList([]);
          setProductImgBase64("");
          setProductImgName("");
        },
      });
    }
  };
  const onPreview = async (file) => {
    let src = file.url;

    if (!src) {
      src = await convertFileToBase64(file.originFileObj || file);
    }

    const imgWindow = window.open("", "_blank");
    if (imgWindow) {
      imgWindow.document.write(`<img src="${src}" style="max-width: 100%;" />`);
      imgWindow.document.title = "Image Preview";
    } else {
      console.error("Failed to open preview window.");
    }
  };
  const onFinish = async (values) => {
    if (!isValidFile) {
      message.error(
        intl.formatMessage({
          id: "Upload.InvalidFileBeforeSubmit",
        })
      );
      return;
    }
    // const warrantyInDays = calculateWarrantyInDays(
    //   values.warrantyValue,
    //   values.warrantyUnit
    // );
    const payload = {
      id: productId ? productId : 0,
      name: values.name,
      typeId: values.type,
      categoryId: values.category,
      classId: values.class,
      description: values.description,
      salePrice: parseFloat(values.salesprice),
      cost: parseFloat(values.cost),
      markup: parseFloat(values.markup),
      taxId: values.salestax,
      isActive: values.status,
      mappedCompany: companyId,
      quantityOnHand: values.quantityOnHand
        ? parseFloat(values.quantityOnHand)
        : null,
      reorderPoint: values.reorder ? parseFloat(values.reorder) : null,
      asOfDate: values.asofdate ? values.asofdate.format("YYYY-MM-DD") : null,
      warranty: values.warranty || null,
      warrantyUnitId: values.warrantyUnitId || null,
      originalFileName: productImgName || null,
      imageBase64: productImgBase64 || null,
    };
    // if (values.warrantyValue && values.warrantyUnit) {
    //   payload.warranty = `${values.warrantyValue} ${values.warrantyUnit}`;
    //   payload.warrantyInDays = warrantyInDays;
    // }
    await Promise.all([
      dispatch(addProductsServicesAPI(payload)).then((res) => {
        if (res) {
          const input = {
            pageNo: props?.currentPage || 1,
            pageSize: 10,
            searchQuery: "",
          };
          dispatch(getProductsServicesAPI(input));
          // navigate(`/products_services`);
          form.resetFields();
          props?.onClose();
          props?.setNewProduct(payload.name);
        }
      }),
    ]);
  };
  // const calculateWarrantyInDays = (value, unit) => {
  //   if (!value || !unit) return null;

  //   switch (unit) {
  //     case "Week(s)":
  //       return value * 7;
  //     case "Month(s)":
  //       return value * 30;
  //     case "Year(s)":
  //       return value * 365;
  //     default:
  //       return null;
  //   }
  // };

  const onChange = (key) => {
    console.log(key);
  };
  const handleClose = () => {
    Modal.confirm({
      title: intl.formatMessage({ id: "Common.AreYouSureToCancel" }),
      content: intl.formatMessage({
        id: "Common.PopConfirm",
      }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      cancelText: intl.formatMessage({ id: "Common.No" }),
      onOk: () => {
        props.onClose();
        form.resetFields();
        setFileList([]);
        setProductImgBase64("");
        setProductImgName("");
      },
    });
  };
  const dayUnitId = warrantyUnits?.find((unit) => {
    const name = selectedLanguage === "fr-FR" ? unit.nameFr : unit.nameEn;
    return name === "Days" || name === "Jours";
  })?.id;
  useEffect(() => {
    dispatch(getProductsTypeAPI());
    dispatch(getDepartmentsAPI());
    dispatch(getCategoriesAPI());
    dispatch(getSalesTaxAPI());
    dispatch(getWarrantyUnitsAPI());
    if (productId > 0) {
      dispatch(getProductByIdAPI(productId));
    }
  }, [dispatch, productId]);
  useEffect(() => {
    if (!productId) {
      form.resetFields();
      setFileList([]);
      setProductImgBase64("");
      setProductImgName("");
    } else if (productDetails) {
      const typeName = productTypesList?.find(
        (type) => type.id === props.productData.typeId
      )?.[selectedLanguage === "fr-FR" ? "nameFr" : "nameEn"];
      if (typeName === "Non-Inventory" || typeName === "Hors inventaire") {
        setShowInventoryInfo(true);
        setActiveKeys((prev) => [...prev, "2"]);
      } else {
        setShowInventoryInfo(false);
      }
      if (productDetails.warranty) {
        const [warrantyValue, warrantyUnit] =
          productDetails.warranty.split(" ");
        form.setFieldsValue({
          warrantyValue: parseInt(warrantyValue, 10),
          warrantyUnit: warrantyUnit,
        });
      } else {
        form.setFieldsValue({
          warrantyValue: null,
          warrantyUnit: "Day(s)",
        });
      }
      form.setFieldsValue({
        name: productDetails.name,
        type: productDetails.typeId,
        category: productDetails.categoryId,
        class: productDetails.classId,
        salesprice: productDetails.salePrice,
        cost: productDetails.cost,
        markup: productDetails.markup,
        quantityOnHand: productDetails.quantityOnHand,
        reorder: productDetails.reorderPoint,
        warranty: productDetails.warranty,
        warrantyUnitId: productDetails.warrantyUnitId,
        asofdate: productDetails.asOfDate
          ? dayjs(productDetails.asOfDate, "YYYY-MM-DD")
          : dayjs(),
        salestax: productDetails.taxId,
        status: productDetails.isActive,
        description: productDetails.description,
        //companyName: productDetails.mappedCompany,
      });
      setCost(props.productData.cost || 0);
      setMarkup(props.productData.markup || 0);
      setSalesPrice(props.productData.salePrice || 0);

      if (productDetails.originalFileName && productDetails.imageBase64) {
        setFileList([
          {
            uid: productDetails.id,
            name: productDetails.originalFileName || "",
            status: "done",
            url: `data:image/png;base64,${productDetails.imageBase64}`,
          },
        ]);
      } else {
        setFileList([]);
        setProductImgBase64("");
        setProductImgName("");
      }
    }
  }, [productId, productDetails, form]);

  return (
    <>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        initialValues={{ warrantyUnitId: dayUnitId, formInitialvalues }}
        autoComplete="off"
        size="large"
        onFinish={onFinish}
      >
        <Collapse activeKey={activeKeys} onChange={onChange} size="small">
          <Panel
            header={<FormattedMessage id="ProductService.BasicInfo" />}
            key="1"
            forceRender
          >
            <Row gutter={16} align="middle">
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <Form.Item name="id" hidden />
                <Form.Item label="Product Image">
                  <AttachmentComponent
                    identifier={formTypeId}
                    currentId={productId}
                    getattachments={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                {/* <Form.Item
                  label={<FormattedMessage id="ProductService.MappedCompany" />}
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseentername",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={intl.formatMessage({
                      id: "ProductService.SelectMappedCompany",
                    })}
                    style={{ width: "100%" }}
                    //onChange={handleChange}
                    options={companyNames?.map((company) => ({
                      value: company.id,
                      label: company.companyName,
                    }))}
                  />
                </Form.Item> */}
                <Form.Item
                  label={<FormattedMessage id="ProductService.Product" />}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseenterproductname",
                      }),
                    },
                  ]}
                >
                  <Input
                    placeholder={intl.formatMessage({
                      id: "ProductService.Entername",
                    })}
                    maxLength={200}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Type" />}
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.PleaseselectType",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder={intl.formatMessage({
                      id: "ProductService.Selecttype",
                    })}
                    optionFilterProp="label"
                    options={productTypesList?.map((type) => ({
                      value: type.id,
                      label:
                        selectedLanguage === "fr-FR"
                          ? type.nameFr
                          : type.nameEn,
                    }))}
                    onChange={handleTypeChange}
                    open={dropdownOpenType}
                    onDropdownVisibleChange={setDropdownOpenType}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Class" />}
                  name="class"
                >
                  <Select
                    showSearch
                    placeholder={intl.formatMessage({
                      id: "ProductService.Selectclass",
                    })}
                    optionFilterProp="label"
                    options={departmentsList?.map((dept) => ({
                      value: dept.id,
                      label:
                        selectedLanguage === "fr-FR"
                          ? dept.nameFr
                          : dept.nameEn,
                    }))}
                    open={dropdownOpenClass}
                    onDropdownVisibleChange={setDropdownOpenClass}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Category" />}
                  name="category"
                >
                  <Select
                    showSearch
                    placeholder={intl.formatMessage({
                      id: "ProductService.Selectcategory",
                    })}
                    optionFilterProp="label"
                    options={categoriesList?.map((category) => ({
                      value: category.id,
                      label:
                        selectedLanguage === "fr-FR"
                          ? category.nameFr
                          : category.nameEn,
                    }))}
                    open={dropdownOpenCategory}
                    onDropdownVisibleChange={setDropdownOpenCategory}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Warranty" />}
                >
                  <Input.Group compact>
                    <Form.Item
                      name="warranty"
                      noStyle
                      rules={[
                        {
                          validator: (_, value) => {
                            if (
                              value === undefined ||
                              value === null ||
                              value === ""
                            ) {
                              return Promise.resolve();
                            }
                            if (value > 999) {
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: "ProductService.WarrantyTooHigh",
                                  })
                                )
                              );
                            }
                            if (value < 0) {
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: "ProductService.WarrantyNegative",
                                  })
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        min={0}
                        max={999}
                        style={{ width: "60%" }}
                        placeholder={intl.formatMessage({
                          id: "ProductService.EnterWarranty",
                        })}
                      />
                    </Form.Item>
                    <Form.Item
                      name="warrantyUnitId"
                      noStyle
                      rules={[{ required: false }]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "40%" }}
                        placeholder="Select Unit"
                        allowClear
                      >
                        {warrantyUnits?.map((unit) => (
                          <Select.Option key={unit.id} value={unit.id}>
                            {selectedLanguage === "fr-FR"
                              ? unit.nameFr
                              : unit.nameEn}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {productId > 0 ? (
                  <Form.Item
                    label={<FormattedMessage id="ProductService.Status" />}
                    name="status"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "ProductService.Pleaseselectstatus",
                        }),
                      },
                    ]}
                    initialValue={true}
                  >
                    <Select
                      showSearch
                      placeholder={intl.formatMessage({
                        id: "ProductService.Selectstatus",
                      })}
                      optionFilterProp="children"
                      options={[
                        {
                          value: true,
                          label: <FormattedMessage id="Common.Active" />,
                        },
                        {
                          value: false,
                          label: <FormattedMessage id="Common.InActive" />,
                        },
                      ]}
                      allowClear
                      filterOption={(input, option) => {
                        const text = intl.formatMessage({
                          id: option.value
                            ? "Common.Active"
                            : "Common.InActive",
                        });
                        return text.toLowerCase().includes(input.toLowerCase());
                      }}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item name="status" initialValue={true} hidden>
                    <Input />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Panel>
          {showInventoryInfo && (
            <Panel
              header={<FormattedMessage id="ProductService.InventoryInfo" />}
              key="2"
              forceRender
            >
              <Row gutter={16} align="middle">
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <FormattedMessage id="ProductService.InitialQtyOnHand" />
                    }
                    name="quantityOnHand"
                  >
                    <Input
                      placeholder={intl.formatMessage({
                        id: "ProductService.InitialQtyOnHand",
                      })}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={<FormattedMessage id="ProductService.AsOfDate" />}
                    name="asofdate"
                    initialValue={dayjs()}
                  >
                    <DatePicker style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label={
                      <FormattedMessage id="ProductService.ReorderPoint" />
                    }
                    name="reorder"
                  >
                    <Input
                      placeholder={intl.formatMessage({
                        id: "ProductService.ReorderPoint",
                      })}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          )}
          <Panel
            header={<FormattedMessage id="ProductService.Sales" />}
            key="3"
            forceRender
          >
            <Row gutter={16} align="middle">
              <Col span={24}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Description" />}
                  name="description"
                >
                  <TextArea
                    rows={4}
                    placeholder={intl.formatMessage({
                      id: "ProductService.Descriptionmax",
                    })}
                    maxLength={255}
                    showCount
                  />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Price/Rate"
                  name="pricerate"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="Enter Price/Rate" maxLength={200} />
                </Form.Item>
              </Col> */}
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Cost" />}
                  name="cost"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseentercost",
                      }),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={intl.formatMessage({
                      id: "ProductService.EnterCost",
                    })}
                    min={0}
                    max={99999}
                    precision={2}
                    maxLength={8}
                    style={{ width: "100%" }}
                    addonAfter="$"
                    onChange={(value) => {
                      setCost(value || 0);
                      calculateSalesPrice(value, markup);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Markup" />}
                  name="markup"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseentermarkup",
                      }),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={intl.formatMessage({
                      id: "ProductService.EnterMarkup",
                    })}
                    min={0}
                    max={99999}
                    //precision={2}
                    maxLength={8}
                    style={{ width: "100%" }}
                    onChange={(value) => {
                      setMarkup(value || 0);
                      calculateSalesPrice(cost, value);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label={<FormattedMessage id="ProductService.Salesprice" />}
                  name="salesprice"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseentersalesprice",
                      }),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={intl.formatMessage({
                      id: "ProductService.EnterSalesprice",
                    })}
                    value={salesPrice}
                    disabled
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
          {/* <Panel header="Purchasing" key="4">
            <Row gutter={16} align="middle">
              <Col span={24}>
                <Form.Item
                  label="Purchase Description"
                  name="purchasedescription"
                >
                  <TextArea
                    rows={4}
                    placeholder={intl.formatMessage({
                      id: "ProductService.Descriptionmax",
                    })}
                    maxLength={255}
                    showCount
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Purchase Cost"
                  name="purchasecost"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "ProductService.Pleaseenterprice",
                      }),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder="Enter purchase cost"
                    min={0}
                    max={99999}
                    precision={2}
                    maxLength={8}
                    style={{ width: "100%" }}
                    addonAfter="$"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Purchase Tax"
                  name="purchasetax"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Purchase Tax"
                    style={{ width: "100%" }}
                    onChange={handleChange}
                    options={[
                      { value: "Purchase Tax1", label: "Purchase Tax1" },
                      { value: "Purchase Tax2", label: "Purchase Tax2" },
                      { value: "Purchase Tax3", label: "Purchase Tax3" },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Purchase Supplier"
                  name="purchaseSupplier"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Purchase Supplier"
                    style={{ width: "100%" }}
                    onChange={handleChange}
                    options={[
                      {
                        value: "Purchase Supplier1",
                        label: "Purchase Supplier1",
                      },
                      {
                        value: "Purchase Supplier2",
                        label: "Purchase Supplier2",
                      },
                      {
                        value: "Purchase Supplier3",
                        label: "Purchase Supplier3",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Panel> */}
        </Collapse>
        <Row gutter={16} align="middle">
          <Col span={24} className="text-center mt-10">
            <Space>
              <Button
                danger
                variant="outlined"
                size="medium"
                onClick={handleClose}
              >
                <CloseCircleOutlined />
                {<FormattedMessage id="Common.Cancel" />}
              </Button>
              <Button type="primary" size="medium" htmlType="submit">
                <CheckCircleOutlined />
                {productId > 0 ? (
                  <FormattedMessage id="ProductService.Save" />
                ) : (
                  <FormattedMessage id="ProductService.AddProduct" />
                )}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default AddProduct;
